import { motion } from "framer-motion";
import { Logo } from "./Logo";
import { WaButton } from "./WhatsAppIcon";
import { WA_DEFAULT_LINK, HOURS } from "../constants/site";

export const Navbar = () => (
    <motion.header
        initial={{ y: -70, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
        className="fixed inset-x-0 top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-graphite/10"
        data-testid="navbar"
    >
        <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
            <a href="#inicio" className="shrink-0" aria-label="REFRIGELAR — início">
                <Logo />
            </a>
            <div className="flex items-center gap-5">
                <span className="hidden lg:flex items-center gap-2 font-technical font-medium uppercase tracking-[0.14em] text-xs text-graphite/60">
                    <span className="w-1.5 h-1.5 rounded-full bg-wa animate-pulse" />
                    {HOURS}
                </span>
                <WaButton href={WA_DEFAULT_LINK} testId="navbar-whatsapp-cta" size="sm">
                    Atendimento
                </WaButton>
            </div>
        </div>
    </motion.header>
);
